import { render, staticRenderFns } from "./MyCarDetailsInformation.vue?vue&type=template&id=0289a6b2&scoped=true&"
import script from "./MyCarDetailsInformation.vue?vue&type=script&lang=js&"
export * from "./MyCarDetailsInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0289a6b2",
  null
  
)

export default component.exports